import { Component, computed, input } from '@angular/core'

import { WorkspaceType } from '@flowx/designer/modules/workspaces/shared/commons.types'

type WorkspaceEnvTypeTagSize = 'default' | 'small'

const CLASSES_BY_SIZE: Record<WorkspaceEnvTypeTagSize, string> = {
  default: 'px-2 text-xs/[18px] font-semibold',
  small: 'px-1.5 text-2xs/4 font-bold tracking-[0.03em]',
}

@Component({
  selector: 'flx-workspace-env-type-tag',
  template: `
    <div
      [class]="styleClass()"
      class="w-fit rounded-2xl text-neutral-50"
    >
      {{ name() }}
    </div>
  `,
})
export class WorkspaceEnvTypeTagComponent {
  envType = input.required<WorkspaceType>()
  name = input.required<string>()
  size = input<WorkspaceEnvTypeTagSize>('default')

  backgroundColor = computed(() => {
    const envType = this.envType()

    return (
      {
        [WorkspaceType.SANDBOX]: 'bg-blue-500',
        [WorkspaceType.STAGING]: 'bg-yellow-500',
        [WorkspaceType.PRODUCTION]: 'bg-neutral-700',
      }[envType] || 'bg-neutral-100'
    )
  })

  textColor = computed(() => {
    const envType = this.envType()

    return (
      {
        [WorkspaceType.STAGING]: 'text-neutral-800',
      }[envType] || 'text-neutral-50'
    )
  })

  styleClass = computed(() => {
    const sizeClasses = CLASSES_BY_SIZE[this.size()]
    const backgroundColor = this.backgroundColor()
    const textColor = this.textColor()
    return `${sizeClasses} ${backgroundColor} ${textColor}`
  })
}
